import React, { useState } from 'react';
import Modal from "@material-ui/core/Modal/Modal";
import DialogContent from "@material-ui/core/DialogContent/DialogContent";
import Button from "@material-ui/core/Button/Button";
import { reactGaEvent } from "examsbook-react-sdk/actions/Common";
import './feedbackModel.scss';
import { useTranslations } from "examsbook-react-sdk/custom-hooks";

/**
 * FeedbackModel of Main site
 * @param props
 * @returns {*}
 * @constructor
 */
function FeedbackModel(props) {
    const { isFeedbackModelOpen, closeFeedBackModel } = props;
    const t = useTranslations();
    const [ message, setMessage ] = useState('');

    function onTextChange(event) {
        setMessage(event.target.value);
    }

    function onSubmit() {
        props.submitForm(message);
        setMessage('');
        reactGaEvent("Feedback ", "Feedback Submit");
    }

    return (
        <div>
            <Modal className="feedback-modal result-feedback-modal"
                   aria-labelledby="simple-modal-title"
                   aria-describedby="simple-modal-description"
                   open={isFeedbackModelOpen}>
                <DialogContent>
                    <div>
                        <div className="feedback-screen">
                            <div className="feedback-close" onClick={closeFeedBackModel}>
                                <i className="fa fa-close"/>
                            </div>
                            <div className="feedback-heading">
                                <h2>{t('feedback')}</h2>
                            </div>
                            <div className="feedback-block">
                                    <textarea placeholder="Please Type Your Suggestion Here" value={message}
                                              onChange={onTextChange}/>
                            </div>
                            <div className="feedback-submit">
                                <Button disabled={!message} onClick={onSubmit}>{t('submit_feedback')}</Button>
                            </div>
                        </div>
                    </div>
                </DialogContent>
            </Modal>
        </div>
    );
}

export default FeedbackModel;
